import { forwardRef } from "react";
import { SelectorAvatarStack } from "./selector-avatar";
import { SelectorPlaceholder, SelectorTrigger } from "./selector-trigger";
import type { SelectorGroup, SelectorTriggerProps } from "./types";

export interface GroupSelectProps extends Omit<SelectorTriggerProps, "value"> {
  value?: SelectorGroup;
}

export const GroupSelect = forwardRef<HTMLButtonElement, GroupSelectProps>(
  function GroupSelect(
    { value, placeholder = "Select a brand group", size = "md", ...props },
    ref
  ) {
    return (
      <SelectorTrigger
        ref={ref}
        placeholder={placeholder}
        size={size}
        {...props}
      >
        {!value ? (
          <SelectorPlaceholder>{placeholder}</SelectorPlaceholder>
        ) : (
          <span className="flex min-w-0 flex-1 items-center gap-1">
            <span className="truncate text-neutral-800">{value.label}</span>
            <SelectorAvatarStack
              accounts={value.accounts || []}
              max={4}
              size={20}
            />
          </span>
        )}
      </SelectorTrigger>
    );
  }
);
